import React from 'react'
import { useHistory } from 'react-router-dom'
import { Icon } from '@dasa-health/components-react'
import { ArrowLeft } from '@dasa-health/alma-icons'
import { useSignUpStepper } from 'redesign/hooks/useSignUpStepper'
import LogoNav from 'assets/logo.svg'
import { LinkProps } from 'typings/components'
import { Header } from 'components'
import { SignUpStepper } from 'redesign/components/molecules/SignUpStepper'
import { LogoContainer } from './styles'

type SignUpHeaderProps = {
    boldText?: string
    link?: LinkProps
    showDot?: boolean
    showStepper?: boolean
    showHistoryBack?: boolean
    title?: string
    subtitle?: string
}

export const SignUpHeader = ({ showHistoryBack = true, showStepper = false, ...props }: SignUpHeaderProps) => {
    const history = useHistory()
    const { step, size } = useSignUpStepper()

    return (
        <header>
            <LogoContainer>
                <Icon
                    as="button"
                    className="button-go-back"
                    onClick={() => {
                        history.goBack()
                    }}
                    size={24}
                >
                    <ArrowLeft />
                </Icon>

                <img alt="Nav Dasa" src={LogoNav} />
            </LogoContainer>
            {showStepper && <SignUpStepper currentValue={step} size={size} />}
            <Header showNavBrand={false} {...props} />
        </header>
    )
}
